export default "__VITE_ASSET__DRrbUvlh__"